import React, { useRef } from 'react'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import Rails from '@rails/ujs'
import InputText from '../form/InputText'

const NOT_EMPTY_FIELD = 'Can\'t be empty'
const NOT_VALID_URL = 'Not a valid URL'


function isValidHttpUrl(url) {
    try {
        const newUrl = new URL(url)
        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:'
    } catch (err) {
        return false
    }
}

function SalesforceConfig(props) {
    const { register, errors, trigger } = useForm({
        defaultValues: props.config
    })

    const formRef = useRef()

    const handleSubmit = async (e) => {
        if (await trigger()) {
            formRef.current.submit()
            e.target.disabled = true
        }
    }

    return <form action={`${props.action}`} method='POST'
                 ref={formRef}
                 className='flex flex-col p-2 font-light wizard-step-collapse-animation' autoComplete='off'>
        <input type='hidden' name='authenticity_token' value={Rails.csrfToken()}/>
        <InputText name='NA'
                   label='NA'
                   ref={register({
                       required: { value: true, message: NOT_EMPTY_FIELD },
                       validate: { url: v => isValidHttpUrl(v) || <p>{NOT_VALID_URL}</p> }
                   })}
                   error={errors?.NA}
        />

        <InputText name='EMEA'
                   label='EMEA'
                   ref={register({
                       required: { value: true, message: NOT_EMPTY_FIELD },
                       validate: { url: v => isValidHttpUrl(v) || <p>{NOT_VALID_URL}</p> }
                   })}
                   error={errors?.EMEA}
        />
        <InputText name='ALAO'
                   label='ALAO'
                   ref={register({
                       required: { value: true, message: NOT_EMPTY_FIELD },
                       validate: { url: v => isValidHttpUrl(v) || <p>{NOT_VALID_URL}</p> }
                   })}
                   error={errors?.ALAO}
        />
        <div className={'flex flex-row-reverse'}>
            <button type='submit' onClick={(e) => {
                e.preventDefault()
                handleSubmit(e)
            }} className='btn-yellow w-38'>Save
            </button>
        </div>
    </form>
}

SalesforceConfig.propTypes = {
    action: PropTypes.string,
    config: PropTypes.object
}

export default SalesforceConfig
